import React, { Component } from "react";
import ImageclosePopup from "../../images/Close-blog-popup.svg";
import IconRightArrow from "../../icons/icon-thank-you-arrow-right.svg"
import 'react-phone-input-2/lib/style.css';
import { Link } from "gatsby";
import IconCheckmarkImage from "../../icons/icon-checkmark.svg";
import $ from "jquery";
import { submitForm } from '../common/templates/form/submitForm';

const emailValidation = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(?!hotmail|gmail|yahoo|outlook|test|yop)(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);


class BlogPopupDownload extends Component {

  constructor(props) {
    super(props);

    this.textInput = null;
    this.referrer = null;
    this.state = {
      name: "",
      nameValidation: "",
      lastName: "",
      email: "",
      emailValidation1: "",
      companyname: "",
      companynameValidation: "",
      shouldSubmit: false,
      showSuccess: false,
      submitButtonState: "",
    };
  }

  componentDidUpdate() {
    this.props.isVisible && this.nameRef.current.focus();
    this.referrer = document.referrer;
  }

  clearFields = () => {
    this.setState({
      name: "",
      nameValidation: "",
      email: "",
      emailValidation: "",
      companyname: "",
      companynameValidation: "",
      shouldSubmit: false,
      showSuccess: false,
      submitButtonState: ""
    });
  };

  checkFields = () => {
    const { nameValidation, emailValidation, companynameValidation } = this.state;
    if (nameValidation === 'success-field' &&
      emailValidation === 'success-field' &&
      companynameValidation === 'success-field') {
      this.setState({
        shouldSubmit: true
      });
    }
    return {
      ...(!nameValidation) && { nameValidation: 'error-field', shouldSubmit: false },
      ...(!emailValidation) && { emailValidation: 'error-field', shouldSubmit: false },
      ...(!companynameValidation) && { companynameValidation: 'error-field', shouldSubmit: false },
    };
  };

  closeDownloadPopup = () => {
    $('.blogPage-download-popup').addClass('hide-popup').removeClass('show-popup');
    setTimeout(function () {
      $('.blogPage-download-popup').remove();
    }, 500);
  }

  hidepopup = () => {
    $('.form-section-blog-popup, .blog-from-overlay').addClass('hide-popup').removeClass('show-popup');
  }

  showpopup = () => {
    $('.form-section-blog-popup, .blog-from-overlay').addClass('show-popup');
  }

  onSubmit = (event) => {
    event.preventDefault();
    if (this.state.submitButtonState === '') {
      this.setState(this.checkFields(),
        async () => {
          if (this.state.shouldSubmit) {
            this.setState({
              submitButtonState: "inProgress"
            });
            let formData = new FormData();
            formData.append("form_id", 12);
            formData.append("input_1", this.state.name);
            formData.append("input_3", this.state.email);
            formData.append("input_5", this.referrer);
            formData.append("input_6", this.props.location.pathname);
            formData.append("input_7", this.state.companyname);
            formData.append("input_8", this.state.lastName)
            formData.append("input_12", "https://www.rapidops.com/resources/2021-SUPPLY-CHAIN-THREATS-OPPORTUNITIES-INFOGRAPHIC.pdf");
            formData.append("input_13", "Rapidops - Your Executive Compass to 2021 Supply Chain Threats & Opportunities");
            formData.append("input_14", "2021 Executive Compass for Manufacturing")

            const requestData = {
              method: 'post',
              url: 'https://rapidopsbackend.kinsta.cloud/wp-json/gf/v2/forms/12/submissions',
              data: formData
            };

            try {
              const response = await submitForm(requestData);
              if (response.status === 200 || response.status === 201) {
                setTimeout(() => {
                  this.setState({
                    submitButtonState: "finished",
                    isVisible: false
                  });
                  $('.blogPage-download-popup').remove();
                }, 100);
              }
              setTimeout(() => {
                this.clearFields();
                this.setState({
                  showSuccess: true
                })
              }, 100);
            }
            catch (error) {
              console.log(error);
            }
          }
        });
    }
  };

  handleChange = (e) => {
    const name = e.target ? e.target.name : 'phone';
    const value = e.target ? e.target.value : e;
    switch (name) {
      case 'name':
        if (!value)
          this.setState({
            nameValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            nameValidation: 'success-field',
          });
        break;


      case 'email':
        if (!emailValidation.test(value))
          this.setState({
            emailValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            emailValidation: 'success-field',
          });
        break;


      case 'companyname':
        if (value.length < 5)
          this.setState({
            companynameValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            companynameValidation: 'success-field',
          });
        break;

      default:
        break;
    }
    const newState = {};
    newState[name] = value;
    this.setState(newState);
  };


  render() {
    const { nameValidation, emailValidation, companynameValidation, showSuccess, submitButtonState } = this.state;
    return(
    <div>
      <div className="blogPage-download-popup">
        <div className="popup-inner">
          <p className="h5">Get access to <strong>70+</strong> insights from <strong>20+</strong> industry sources</p>
          <p>Rethink and reshape your supply chains to be digital, resilient, and efficient. Download your free copy today!</p>
          <button className="button right-arrow" onClick={this.showpopup}>Download</button>
        </div>
        <div className="closepopup" role="button" onClick={this.closeDownloadPopup} onKeyDown={this.closeDownloadPopup} tabIndex={0}><img src={ImageclosePopup} alt="close popup" /></div>
      </div>
      <div className="blog-from-overlay"></div>
      <div className="form-section-blog-popup" id="form-section">
        <div className="closepopup" role="button" onClick={this.hidepopup} onKeyDown={this.hidepopup} tabIndex={0}><img src={ImageclosePopup} alt="close popup" /></div>
        {!showSuccess &&
          <div className="form-section-blog-inner">
            <span className="form-title h5">Download your <strong>FREE</strong> guide now!</span>
            <p>Fill in the details below.</p>
            <form name="blog" onSubmit={this.onSubmit} className="fomt-style-round">
              <div className="form-row has-two-column">
                <div className="form-column">
                  <label htmlFor="firstname">First Name <span>*</span></label>
                  <input ref={(elem) => (this.textInput = elem)} type="text" className={`form-input LoNotSensitive ${nameValidation}`} id="name" name="name" autoComplete="off" onChange={this.handleChange} value={this.state.name} tabIndex={0} />
                </div>
                <div className="form-column">
                  <label htmlFor="lastname">Last Name</label>
                  <input  type="text" className="form-input LoNotSensitive" id="lastName" name="lastName" autoComplete="off" onChange={this.handleChange} value={this.state.lastName} tabIndex={0} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="workmail">Work Email <span>*</span></label>
                  <input type="email" name="email" className={`form-input LoNotSensitive ${emailValidation}`} id="email" autoComplete="off" onChange={this.handleChange} value={this.state.email} tabIndex={0} />
                  <small className={`${emailValidation}`}>Please enter your work email.</small>
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="companyname">Company Name <span>*</span></label>
                  <input ref={this.nameRef} type="text" className={`form-input LoNotSensitive ${companynameValidation}`} id="companyname" name="companyname" autoComplete="off" onChange={this.handleChange} value={this.state.companyname} tabIndex={0} />
                </div>
              </div>
              <div className="form-action">
                <p>By submitting this form you agree to our <Link to="/privacy-policy/">Privacy Policy</Link>.</p>
                <button type="submit" className={`button right-arrow button-black  ${submitButtonState}`} tabIndex={0} >
                  <span className="submit">Download</span>
                  <span className="loading"> Download </span>
                  <span className="check"> <IconCheckmarkImage /> </span>
                </button>

              </div>
            </form>
          </div>
        }
        {showSuccess &&
          <div className="thank-you-blog">
            <h3>Thank you for downloading! </h3>
            <p>Please check your email for the Infographic on<span className="green-color"> 2021 Supply Chains Threats & Opportunities.</span></p>
            <strong className="h3">TAKE THE NEXT STEP &nbsp; <IconRightArrow /> </strong>
            <p className="mb-40">Want to explore your opportunities with our digital manufacturing and supply chain solutions? Just drop us a line.</p>
            <Link to="/contact/" className="button right-arrow button-black">Contact Us</Link>
          </div>
        }
      </div>
    </div>
    )
  }
}


export default BlogPopupDownload;